<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import SimpleLayout from '@/layouts/SimpleLayout.vue'

const DEFAULT_LAYOUT = 'DefaultLayout'

const LAYOUTS = {
  DefaultLayout,
  BlankLayout,
  SimpleLayout,
}

export default {
  name: 'App',
  components: {
    ...LAYOUTS,
  },

  computed: {
    layout() {
      const { layout } = this.$route.meta
      return LAYOUTS[layout] ? layout : DEFAULT_LAYOUT
    },
  },
}
</script>